import { useTranslation } from 'react-i18next';

import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import B2CVerificationOverviewCard from './B2CVerificationOverviewCard';

const B2CVerificationOverviewPage = () => {
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <PageMetatags title={t('pages:verification.overview.meta.title')} />
      <B2CVerificationOverviewCard />
    </ContentLayout>
  );
};

export default B2CVerificationOverviewPage;
